import React from 'react';
import PropTypes from 'prop-types';
import Button from '@ublend-npm/aulaui-next-web/Button';
import Tooltip from '@ublend-npm/react-tooltip';

import BigBlueButtonLogo from '../../../../../static/bbb.png';
import { Logo } from './BigBlueButton.styled';

const BigBlueButton = ({ description, launchMeeting, launchingMeeting }) => (
  <Tooltip title={description} position="bottom">
    <Button onClick={launchMeeting} loading={launchingMeeting}>
      <Logo src={BigBlueButtonLogo} alt="BigBlueButton" />
    </Button>
  </Tooltip>
);

BigBlueButton.propTypes = {
  description: PropTypes.string.isRequired,
  launchMeeting: PropTypes.func.isRequired,
  launchingMeeting: PropTypes.bool.isRequired,
};

export default BigBlueButton;
